import React, { useState, useEffect } from "react";
import { toast, Toaster } from "react-hot-toast";
import { getCountryCodeAction } from "../../Action/propertyOwner.action";
import {getUserProfileInfos} from "../../Action/user.action";
import Select from "react-select";
import { Card } from "react-bootstrap";
import "../commanComponents/componentCSS/guestform.css";
import Cookies from "js-cookie";

const GuestForm = ({ onStatusChange, onSubmitFormData, noOfRoomBooked }) => {
  const loginData = !Cookies.get("loginSuccessPropertyOwner")
    ? []
    : JSON.parse(Cookies.get("loginSuccessPropertyOwner"));
  
  
    console.log("loginData", loginData);

  const [formData, setFormData] = useState({
    email: "",
    countryCode: "",
    phone: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
  });

  const [guestName, setGuestName] = useState(
    Array.from({ length: noOfRoomBooked }, () => ({
      title: "",
      firstName: "",
      lastName: "",
    }))
  );

  const [formErrors, setFormErrors] = useState({});
  const [guestErrors, setGuestErrors] = useState([]);
  const [countryCodeOption, setCountryOption] = useState([]);
  const [countryCode, setcountryCode] = useState({
    label: "+592",
    value: "592",
  });

 useEffect(() => {
  getCountryCodeAPI();
}, []);

useEffect(() => {
  // Only call this when country codes are available
  if (countryCodeOption.length > 0) {
    getUserProfileDetailAPI();
  }
}, [countryCodeOption]);

  const getCountryCodeAPI = async () => {
    let res = await getCountryCodeAction();
    if (res.success) {
      const options = res.data.map((x) => ({
        label: `+${x.phonecode}`,
        value: x.phonecode.toString(),
      }));
      setCountryOption(options);
      const guyana = options.find((opt) => opt.value === "592");
      if (guyana) {
        setcountryCode(guyana);
        setFormData((prev) => ({ ...prev, countryCode: guyana.value }));
      }
    }
  };

 const getUserProfileDetailAPI = async () => {
  let res = await getUserProfileInfos();
  if (res.success) {
    const { email, mobileNumber, countryCode, address, firstName, lastName } = res.data;

    setFormData((prev) => ({
      ...prev,
      email: email || "",
      phone: mobileNumber || "",
      addressLine1: address !== "null" ? address : "",
      countryCode: countryCode?.toString() || "",
    }));

    // Update country code select value
    const selectedCode = countryCodeOption.find((opt) => opt.value === countryCode?.toString());
    if (selectedCode) {
      setcountryCode(selectedCode);
    }

    // Fill the first guest by default
    const updatedGuests = [...guestName];
    if (updatedGuests.length > 0) {
      updatedGuests[0] = {
        ...updatedGuests[0],
        firstName: firstName || "",
        lastName: lastName || "",
      };
    }
    setGuestName(updatedGuests);
  }
};


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleGuestChange = (index, e) => {
    const { name, value } = e.target;
    const updatedGuests = [...guestName];
    updatedGuests[index][name] = value;
    setGuestName(updatedGuests);

    const updatedErrors = [...guestErrors];
    if (updatedErrors[index]) {
      updatedErrors[index][name] = "";
      setGuestErrors(updatedErrors);
    }
  };

  const validate = () => {
    const errors = {};
    const guestErrs = guestName.map((guest) => {
      const gErr = {};
      if (!guest.title) gErr.title = "Please select a title";
      if (!guest.firstName) gErr.firstName = "First name is required";
      if (!guest.lastName) gErr.lastName = "Last name is required";
      return gErr;
    });

    if (!formData.email) {
      errors.email = "Email is required";
    }
    // else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    //     errors.email = 'Please enter a valid email address';
    // }

    if (!formData.countryCode) {
      errors.countryCode = "Country code is required";
    }

    if (!formData.phone) {
      errors.phone = "Phone number is required";
    } else if (!/^\d{7,15}$/.test(formData.phone)) {
      errors.phone = "Phone number must be between 7 and 15 digits";
    }

    if (!formData.addressLine1)
      errors.addressLine1 = "Address Line 1 is required";
    if (!formData.country) errors.country = "Country is required";
    if (!formData.state) errors.state = "State/Region is required";
    if (!formData.city) errors.city = "City/Town/Village is required";


    return { errors, guestErrs };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { errors, guestErrs } = validate();

    if (
      Object.keys(errors).length > 0 ||
      guestErrs.some((err) => Object.keys(err).length > 0)
    ) {
      setFormErrors(errors);
      setGuestErrors(guestErrs);
      onStatusChange(false);
      return;
    }

    try {
      onSubmitFormData({ ...formData, guestName });
      onStatusChange(true);
    } catch (error) {
      console.error("Error sending form data:", error);
      onStatusChange(false);
    }
  };

  const renderError = (field) =>
    formErrors[field] && (
      <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
        {formErrors[field]}
      </div>
    );

  const renderGuestError = (index, field) =>
    guestErrors[index] &&
    guestErrors[index][field] && (
      <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
        {guestErrors[index][field]}
      </div>
    );

  return (
    <div className="container mt-4 guestForm">
      <h5 className="fw-bold mb-3">Guest Information</h5>

      <form onSubmit={handleSubmit}>
        {guestName.map((guest, index) => (
          <Card className="shadow-sm rounded-4 mb-4">
            <Card.Body>
              <div key={index} className="">
                <h5 className="fw-semibold">Guest {index + 1}</h5>
                <div className="row">
                  <div className="col-3">
                    <div className="mb-3">
                      <label className="form-label">Title</label>
                      <select
                        className="form-select"
                        name="title"
                        value={guest.title}
                        onChange={(e) => handleGuestChange(index, e)}
                      >
                        <option value="">Select Title</option>
                        <option value="Mr">Mr</option>
                        <option value="Mrs">Mrs</option>
                        <option value="Miss">Miss</option>
                        <option value="Dr">Dr</option>
                      </select>
                      {renderGuestError(index, "title")}
                    </div>
                  </div>
                  <div className="col-9">
                    <div className="row ">
                      <div className="col-lg-6 mb-3">
                        <label className="form-label">First Name</label>
                        <input
                          type="text"
                          className="form-control h-auto rounded-2"
                          name="firstName"
                          value={guest.firstName}
                          onChange={(e) => handleGuestChange(index, e)}
                        />
                        {renderGuestError(index, "firstName")}
                      </div>
                      <div className="col-lg-6 mb-3">
                        <label className="form-label">Last Name</label>
                        <input
                          type="text"
                          className="form-control h-auto rounded-2"
                          name="lastName"
                          value={guest.lastName}
                          onChange={(e) => handleGuestChange(index, e)}
                        />
                        {renderGuestError(index, "lastName")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        ))}

        <h5 className="fw-bold mb-3">Contact Information</h5>
        <Card className="shadow-sm rounded-4 mb-4">
          <Card.Body>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control h-auto rounded-2"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
                {renderError("email")}
              </div>

              <div className="col-md-3">
                <label className="form-label">Country Code</label>
                <Select
                  options={countryCodeOption}
                  value={countryCode}
                  onChange={(selectedOption) => {
                    setcountryCode(selectedOption);
                    setFormData((prev) => ({
                      ...prev,
                      countryCode: selectedOption.value,
                    }));
                  }}
                  placeholder="Select code"
                  classNamePrefix="react-select"
                />
                {renderError("countryCode")}
              </div>

              <div className="col-md-3">
                <label className="form-label">Phone</label>
                <input
                  type="text"
                  className="form-control h-auto rounded-2"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {renderError("phone")}
              </div>
            </div>
          </Card.Body>
        </Card>

        <h5 className="fw-bold mb-3">Billing Address</h5>
        <Card className="shadow-sm rounded-4 mb-4">
          <Card.Body>
            <div className="mb-3">
              <label className="form-label">Address Line 1</label>
              <input
                type="text"
                className="form-control h-auto rounded-2"
                name="addressLine1"
                value={formData.addressLine1}
                onChange={handleChange}
              />
              {renderError("addressLine1")}
            </div>
            <div className="mb-3">
              <label className="form-label">Address Line 2</label>
              <input
                type="text"
                className="form-control h-auto rounded-2"
                name="addressLine2"
                value={formData.addressLine2}
                onChange={handleChange}
              />
            </div>
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Country</label>
                <input
                  type="text"
                  className="form-control h-auto rounded-2"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                />
                {renderError("country")}
              </div>
              <div className="col">
                <label className="form-label">State/Region</label>
                <input
                  type="text"
                  className="form-control"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                />
                {renderError("state")}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">City/Town/Village</label>
                <input
                  type="text"
                  className="form-control h-auto rounded-2"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                />
                {renderError("city")}
              </div>
              <div className="col">
                <label className="form-label">Zip Code</label>
                <input
                  type="text"
                  className="form-control h-auto rounded-2"
                  name="zipCode"
                  value={formData.zipCode}
                  onChange={handleChange}
                />
              </div>
            </div>
          </Card.Body>
        </Card>
        <button type="submit" className="btn btn-primary h-auto rounded-2">
          Continue to Pay
        </button>
      </form>
    </div>
  );
};

export default GuestForm;
